'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);


var _components = require('../../components');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _constants = require('../../constants');
var _SimpleMortgageBanner = require('./SimpleMortgageBanner.scss');var styles = _interopRequireWildcard(_SimpleMortgageBanner);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // styles

var SimpleMortgageBanner = function SimpleMortgageBanner(props) {return (
    _react2.default.createElement('div', { className: styles.wrapper },
      _react2.default.createElement(_components.ListBanner, { link: (0, _appendLocale2.default)(props.locale, '/company/' + (_constants.isProd ? 'HJ78sgpIH' : 'r1qtHMerH')) })));};



SimpleMortgageBanner.propTypes = {
  locale: _propTypes2.default.string,
  bannerText: _propTypes2.default.string };exports.default =


SimpleMortgageBanner;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MortgageBanner/SimpleMortgageBanner.js
// module id = 3010
// module chunks = 0